import React, { useEffect, useRef, useState } from 'react';
import './RevealOnScroll.css';

const RevealOnScroll = ({ children, threshold = 0.1, delay = 0, className = '', style = {}, once = false }) => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const currentRef = ref.current;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    if (once && currentRef) {
                        observer.unobserve(currentRef);
                    }
                } else {
                    if (!once) {
                        setIsVisible(false);
                    }
                }
            },
            {
                threshold: threshold,
            }
        );

        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [threshold, once]);

    return (
        <div
            ref={ref}
            className={`reveal-on-scroll ${isVisible ? 'visible' : ''} ${className}`}
            style={{ transitionDelay: `${delay}ms`, ...style }}
        >
            {children}
        </div>
    );
};

export default RevealOnScroll;
